import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { PlayArrow } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
	downloadMedia: {
		display: "flex",
		alignItems: "center",
		padding: 6,
	},
}));

// Áudio sob demanda: não baixa nada até o usuário clicar em "Escutar".
// Evita pré-download automático de todos os áudios (sobrecarga de rede).
const LazyAudio = ({ audioUrl }) => {
	const classes = useStyles();
	const [load, setLoad] = useState(false);

	if (!load) {
		return (
			<div className={classes.downloadMedia}>
				<Button
					startIcon={<PlayArrow />}
					color="primary"
					variant="outlined"
					onClick={() => setLoad(true)}
				>
					Escutar
				</Button>
			</div>
		);
	}

	return (
		<audio controls autoPlay preload="auto">
			<source src={audioUrl} type="audio/ogg" />
		</audio>
	);
};

export default LazyAudio;
